import React, { Component } from "react";
import QuizAdmin from "./QuizAdmin";
import QuizPackAdmin from "./QuizPackAdmin";

export default class QuizAdminSelector extends Component {
  state = {
    view: "Quiz",
  };

  render() {
    return (
      <>
        <section className="section">
          <div className="container">
            <h1>Quiz Admin</h1>
            <br />
            <button
              style={{
                fontSize: "20px",
                border: this.state.view == "Quiz" ? "3px solid #5dab71" : "",
                color: this.state.view == "Quiz" ? "#5dab71" : "",
                background: "white",
                borderRadius: "12px",
                padding: "5px 10px",
              }}
              onClick={() => {
                this.setState({ view: "Quiz" });
              }}
            >
              Quiz
            </button>
            <button
              style={{
                fontSize: "20px",
                border:
                  this.state.view == "Quizpack" ? "3px solid #5dab71" : "",
                color: this.state.view == "Quizpack" ? "#5dab71" : "",
                marginLeft: "10px ",
                background: "white",
                borderRadius: "12px",
                padding: "5px 10px",
              }}
              onClick={() => {
                this.setState({ view: "Quizpack" });
              }}
            >
              Quizpakker
            </button>
            <br />
            {this.state.view == "Quiz" ? <QuizAdmin /> : <QuizPackAdmin />}
          </div>
        </section>
      </>
    );
  }
}
